<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import medicionFrecuenciaAPI from "@/services/standards/medicionFrecuencia/medicionFrecuenciaAPI";
import CheckModal from "@/components/CheckModal";
import medicionMortalidadAPI from "../../../services/standards/medicionMortalidad/medicionMortalidadAPI";
import { downloadLineChartImage } from "@/utils/helpers/chartImage";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.3.3 Medición de la Mortalidad de los AT",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "3.3.3 Medición de la Mortalidad de los AT",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.3.3 Medición de la Mortalidad de los AT",
        },
        {
          text: "Reporte indicador de la mortalidad",
          active: true,
        },
      ],
      years: [],
      show: [],

      listY: [],
      listM: [],
      listMeses: [],
      listA: [],

      mes: null,

      days: {
        period: "mounth",
        year: null,
        mounth: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      meses: [
        {
          id: 1,
          name: "Enero",
        },
        {
          id: 2,
          name: "Febrero",
        },
        {
          id: 3,
          name: "Marzo",
        },
        {
          id: 4,
          name: "Abril",
        },
        {
          id: 5,
          name: "Mayo",
        },
        {
          id: 6,
          name: "Junio",
        },
        {
          id: 7,
          name: "Julio",
        },
        {
          id: 8,
          name: "Agosto",
        },
        {
          id: 9,
          name: "Septiembre",
        },
        {
          id: 10,
          name: "Octubre",
        },
        {
          id: 11,
          name: "Noviembre",
        },
        {
          id: 12,
          name: "Diciembre",
        },
      ],

      chartOptions: {
        lineSmooth: false,
      },

      chartData1: {
        labels: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        series: [
          [],
          [],
        ],
      },

      chartData: {
        labels: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        series: [
          [],
        ],
      },

      chartData2: {
        labels: [],
        series: [
          [],
          [],
          [],
          [],
          [],
        ],
      },

      chartData3: {
        labels: [],
        series: [
          [],
          [],
          [],
          [],
          [],
        ],
      },

      excel: null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID:
        this.$store.getters["company/getCompany"].company_classification_id ||
        null,
      user: this.$store.state.auth || null,
      token: this.$store.state.auth.user.token || null,

      meses: [
        {
          id: 1,
          name: "Enero",
        },
        {
          id: 2,
          name: "Febrero",
        },
        {
          id: 3,
          name: "Marzo",
        },
        {
          id: 4,
          name: "Abril",
        },
        {
          id: 5,
          name: "Mayo",
        },
        {
          id: 6,
          name: "Junio",
        },
        {
          id: 7,
          name: "Julio",
        },
        {
          id: 8,
          name: "Agosto",
        },
        {
          id: 9,
          name: "Septiembre",
        },
        {
          id: 10,
          name: "Octubre",
        },
        {
          id: 11,
          name: "Noviembre",
        },
        {
          id: 12,
          name: "Diciembre",
        },
      ],

      unoA: null,
      dosA: null,
      tresA: null,
      cuatroA: null,
      cincoA: null,
      seisA: null,
      sieteA: null,
      ochoA: null,
      nueveA: null,
      diezA: null,

      unoC: null,
      dosC: null,
      tresC: null,
      cuatroC: null,
      cincoC: null,
      seisC: null,
      sieteC: null,
      ochoC: null,
      nueveC: null,
      diezC: null,

      //-------//
      january_a: null,
      february_a: null,
      march_a: null,
      april_a: null,
      may_a: null,
      june_a: null,
      july_a: null,
      august_a: null,
      september_a: null,
      october_a: null,
      november_a: null,
      december_a: null,
      //-------//

      january_p: null,
      february_p: null,
      march_p: null,
      april_p: null,
      may_p: null,
      june_p: null,
      july_p: null,
      august_p: null,
      september_p: null,
      october_p: null,
      november_p: null,
      december_p: null,
      //-------//
      january_a: null,
      february_a: null,
      march_a: null,
      april_a: null,
      may_a: null,
      june_a: null,
      july_a: null,
      august_a: null,
      september_a: null,
      october_a: null,
      november_a: null,
      december_a: null,
      //-------//
      january_t: null,
      february_t: null,
      march_t: null,
      april_t: null,
      may_t: null,
      june_t: null,
      july_t: null,
      august_t: null,
      september_t: null,
      october_t: null,
      november_t: null,
      december_t: null,

      january_i: null,
      february_i: null,
      march_i: null,
      april_i: null,
      may_i: null,
      june_i: null,
      july_i: null,
      august_i: null,
      september_i: null,
      october_i: null,
      november_i: null,
      december_i: null,
      //-------//
      january_c: null,
      february_c: null,
      march_c: null,
      april_c: null,
      may_c: null,
      june_c: null,
      july_c: null,
      august_c: null,
      september_c: null,
      october_c: null,
      november_c: null,
      december_c: null,
      //-------//
      january_an: null,
      february_an: null,
      march_an: null,
      april_an: null,
      may_an: null,
      june_an: null,
      july_an: null,
      august_an: null,
      september_an: null,
      october_an: null,
      november_an: null,
      december_an: null,

      january_m: null,
      february_m: null,
      march_m: null,
      april_m: null,
      may_m: null,
      june_m: null,
      july_m: null,
      august_m: null,
      september_m: null,
      october_m: null,
      november_m: null,
      december_m: null,
      awesome: null,
      awesome1: null,

      selected: null,

      medicionY: {
        year: null,
      },

      medicionM: {
        start_year: null,
        end_year: null,
      },
    };
  },
  methods: {
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    show(id) {
      medicionFrecuenciaAPI
        .show(id)
        .then((response) => {
          let medicion = response;
          this.show = medicion;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async todos2() {
      this.getGrafica2();
      this.saveM();
    },

    getGrafica2() {

      this.chartData2.labels = []
      this.chartData2.series[0] = []

      medicionMortalidadAPI
        .saveYears(this.companyID, {
          start_year: this.medicionM.start_year,
          end_year: this.medicionM.end_year,
        })
        .then((response) => {
          let medicion = response;
          this.listM = medicion;

          for (let i = 0; i <= this.listM.length; i++) {
            this.chartData2.labels.push(this.listM[i].Año);
            this.chartData2.series[0].push(this.listM[i].modicion_mortalidad);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    saveM() {
      medicionMortalidadAPI
        .saveYears(this.companyID, {
          start_year: this.medicionM.start_year,
          end_year: this.medicionM.end_year,
        })
        .then((response) => {
          let medicion = response;
          this.listM = medicion;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        medicionMortalidadAPI
          .getExcel(
            this.companyID,
            this.medicionM.start_year,
            this.medicionM.end_year
          )
          .then((response) => {
            window.location.href = response;
          });
      } catch (error) {
        console.log(error);
      }
    },

    rangeYear() {
      const max = 2040;
      const min = 2019;
      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years;
    },

    goPage(page) {
      window.location.href = page;
    },

    downloadChartImage() {
      downloadLineChartImage(
        this.chartData2.labels,
        [{ data: this.chartData2.series[0], label: "Mortalidad de accidentalidad" }],
        `mortalidad-anual-${this.medicionM.start_year}-${this.medicionM.end_year}`
      );
    },
  },

  mounted() {
    this.rangeYear();
    this.todos2();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <CheckModal>
                  <p class="text-justify">
                    Este indicador mide la relación de los accidentes mortales
                    con respecto al total de accidentes presentados en la
                    empresa en un año.
                  </p>
                  <p class="text-justify">
                    El responsable de la implementación debe definir la meta del
                    indicador (se espera que sea 0), además que personas deben
                    conocer el resultado.
                  </p>
                </CheckModal>
              </div>

              <div class="col-6 text-right m-b-0">
                <button
                  @click="
                    goPage(`/forms/estandares/${companyID}/medicion-mortalidad`)
                  "
                  class="btn btn-primary mx-1"
                >
                  <span class="btn-label"> </span> Parametrizar periodos
                </button>

                <!--           <button @click="
                                                                goPage(`/forms/estandares/${companyID}/medicion-frecuencia-grafica`)
                                                              " class="btn btn-primary mx-1" id="tooltip">
                                                                <span class="btn-label"> <i class="mdi mdi-arrow-right-bold-outline"></i></span> Generar reporte
                                                              </button>
                                                              <b-tooltip target="tooltip" placement="left">
                                                                Ir a Procedimiento matriz de identificación peligros del sg-sst
                                                              </b-tooltip> -->
              </div>
            </div>

            <hr />

            <form class="row pt-3 pl-2" @submit.prevent="todos2">
              <b-form-group
                id="cycle"
                label-for="cycle"
                class="col-md-2 px-2"
                label="Inicio"
              >
                <b-form-select
                  required
                  class="col-md-8 form-control"
                  v-model="medicionM.start_year"
                >
                  <b-form-select-option v-for="item in years" :value="item">
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <b-form-group
                id="cycle"
                label-for="cycle"
                class="col-md-2 px-2"
                label="Fin"
              >
                <b-form-select
                  required
                  class="col-md-8 form-control"
                  v-model="medicionM.end_year"
                >
                  <b-form-select-option v-for="item in years" :value="item">
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <div class="col-md-4 col-sm-12">
                <button
                  @click="awesome = !awesome"
                  type="submit"
                  name="boton"
                  class="btn btn-primary mt-3"
                >
                  Generar reporte
                </button>
              </div>

              <div
                class="col-md-4 col-sm-12 text-right m-b-0 d-flex justify-content-center align-items-center"
              >
                <button
                  :disabled="this.listM === 0"
                  @click="print"
                  type="button"
                  class="btn btn-primary mx-1"
                  id="tooltip"
                >
                  <span class="btn-label"> <i class="bx bx-download"></i></span>
                  Descargar excel
                </button>

                <b-tooltip target="tooltip" placement="left">
                  Descargar
                </b-tooltip>
              </div>

              <div v-if="awesome" class="col-lg-12 pt-3">
                <div class="text-right mb-2">
                  <button @click="downloadChartImage" type="button" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span>Descargar gráfica
                  </button>
                </div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">
                      Gráfica mortalidad de la accidentalidad
                    </h4>
                    <ul>
                      <li style="color: #00707f">
                        Mortalidad de la accidentalidad
                      </li>
                    </ul>
                    <p class="sub-header"></p>

                    <Chartist
                      ratio="ct-chart"
                      :data="chartData2"
                      :options="chartOptions"
                      type="Line"
                    ></Chartist>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
